/**
 * Why a modified approval input was rejected — a code rather than copy, so
 * the rendering surface owns the localized message.
 */
export type ApprovalInputErrorCode = 'not_an_object' | 'invalid_json';

export type ApprovalInputState =
  | {
      valid: true;
      modifiedInput: Record<string, unknown> | null;
      error: null;
    }
  | {
      valid: false;
      modifiedInput: null;
      error: ApprovalInputErrorCode;
    };

export const parseApprovalInput = (
  modifiedInputText: string,
  originalInputJson: string
): ApprovalInputState => {
  const trimmed = modifiedInputText.trim();
  if (!trimmed || trimmed === originalInputJson.trim()) {
    return { valid: true, modifiedInput: null, error: null };
  }

  try {
    const parsed = JSON.parse(trimmed) as unknown;
    if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return {
        valid: false,
        modifiedInput: null,
        error: 'not_an_object',
      };
    }
    return {
      valid: true,
      modifiedInput: parsed as Record<string, unknown>,
      error: null,
    };
  } catch {
    return {
      valid: false,
      modifiedInput: null,
      error: 'invalid_json',
    };
  }
};
